import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";

export const homeApi = async () => {
    try {
        const response = await axios.get(`${baseUrl}dashboard`, {});
        return response;
    } catch (error) {
        return null;
    }
};